import './../fonts/Beyond-Infinity.ttf.woff';
import './../sass/main.scss';
import $ from 'jquery';

window.$ = $;
window.jQuery = $;

if(typeof wp_object === 'undefined') {
    wp_object = { 'theme_url': '' };
}

$(function() {

    $('.js-faq').click(function(ev) {
        ev.preventDefault();

        if($(this).hasClass('e-faq--expanded')) {
            return $(this).removeClass('e-faq--expanded');
        }

        $('.e-faq--expanded').removeClass('e-faq--expanded');
        $(this).addClass('e-faq--expanded');
    });

    $('.js-expand').click(function(ev) {
        ev.preventDefault();

        let expandClass = $(this).attr('data-expands');
        $('.' + expandClass).toggleClass(expandClass + '--expanded');
    });

    $('.js-updatefilter').keyup(function(ev) {
        if(ev.which == 13) {
            ev.preventDefault();
            $(this).trigger('change');
        }
    });

    $('.js-updatefilter').change(function(ev) {
        $('.e-results').addClass('e-results--mist');
        $('.js-moreproducts').hide();

        $.ajax({
            type: 'GET',
            url: wp_object.theme_url + '/xhr/filter.php',
            data: $('#form_filter').serialize(),
            success: function(msg) {
                $('.js-moreproducts').attr('data-end', '15');
                $('.e-results > .e-tile').css('display', 'none');
                $('.e-results').html(msg).removeClass('e-results--mist');
                $('.js-moreproducts').show().trigger('click');
                $('.js-backtotop').trigger('click');
                $('.e-filter').removeClass('e-filter--expanded');
            },
            error: function(obj, status, msg) {
                $('.e-results').removeClass('e-results--mist');
            }
        });
    });

    $('.js-nosubmit').submit(function(ev) {
        ev.preventDefault();
    });

    $('.js-dealersearch input').on('blur', function() {
        $.ajax({
            type: 'GET',
            url: wp_object.theme_url + '/xhr/find_dealer.php',
            data: { 'zip': $(this).val() },
            dataType: 'json',

            success: function(msg) {
                $('.js-showdealer').html(msg.html);
                if( $('input[name="' + wp_object.gf_dealer_field + '"]').length ) {
                    $('input[name="' + wp_object.gf_dealer_field + '"]').val(msg.id);
                }
            },

            error: function(obj, status, msg) {
                console.log('ERROR! ' + status + ': ' + msg);
            }
        });
    });

    $('.js-entertoblur').keydown(function(ev) {
        console.log(ev.which);
        if(ev.which == 13) {
            ev.preventDefault();
            $(this).trigger('blur');
        }
    });

    $('.js-rollup').each(function() {
        let fontSize = $(document).width() < 768 ? '3.25rem' : '6rem';
        $(this).rollNumber({
            number:   $(this).text(),
            speed:    2000,
            interval: 200,
            fontStyle: {
                'font-size': fontSize
            }
        });
    });

    $('.js-gallery').click(function(ev){
        ev.preventDefault();
        $('.js-gallery').each(function(){
            $(this).parent().removeClass('e-gallery__item--active');
        });
        $(this).parent().addClass('e-gallery__item--active');
        $('.e-gallery__image').attr('src', $('.e-gallery__thumb', $(this)).attr('src'));
    });

    $('.js-setheight').each(function(){
        $(this).css('height', $(this).outerHeight() + 'px' );
    });
    
    $('.u-sticky').each(function() {
        $(this).css('top', 'calc(100vh - ' + $(this).outerHeight() + 'px');
    });

    $('.js-backtotop').hide();
    $(document).on('scroll', function() {
        
        // Only scroll check if product grid exists
        if(!$('.l--productgrid').length) {
            return;
        }

        let scrollTop = $('.l--productgrid').position().top - 140;
        let scrollBottom = scrollTop + $('.l--productgrid').outerHeight();
        let scrollCurrent = $(window).scrollTop();

        if(scrollCurrent > scrollTop && scrollCurrent < scrollBottom) {
            $('.js-backtotop').show(500);
        }
        else {
            $('.js-backtotop').hide(500);
        }

    }).trigger('scroll');

    $('.js-backtotop').click(function(ev) {
        ev.preventDefault();
        $([document.documentElement, document.body]).animate({
            scrollTop: $('[name="filterTop"]').offset().top
        }, 500);
    });
    
    $('.js-moreproducts').click(function(ev) {
        ev.preventDefault();

        let i = 0;
        let $this = $(this);

        $('.e-results > .e-tile').each(function() {
            if(i < $this.attr('data-end')) {
                i++;
                $(this).css('display', 'block');
            }
        });

        if($(this).attr('data-end') >= $('.e-results > *').length ) {
            $(this).hide();
        } else {
            $(this).attr('data-end', 15 + parseInt($(this).attr('data-end')));
        }

    }).trigger('click');

    if($('.js-dealersearch2').length) {
        $('.js-dealersearch2 input').after($('<span class="e-button e-button--pc">Bevestig de postcode</span>'));
    }

    if($('#locatorMap').length) {

        // Init Maps
        initLocatorMaps();

        $('.js-locatestore input').on('blur', function() {

            $.ajax({
                type: 'GET',
                url: wp_object.theme_url + '/xhr/find_dealer.php',
                data: {
                    'zip': $(this).val(),
                    'template': 'locator',
                    'limit': 3,
                },
                dataType: 'json',

                success: function(msg) {
                    // Hide markers
                    if(markers.length) {
                        for(let key in markers) {
                            // markers[key].removeListener('click');
                            markers[key].setMap(null);
                        }
                        markers = [];
                    }

                    // Add new markers
                    for(let key in msg.extra.dealer) {
                        let newMarker = new AdvancedMarkerElement({
                            map: locatorMap,
                            position: {
                                lat: msg.extra.dealer[key].lat,
                                lng: msg.extra.dealer[key].lng
                            },
                            title: msg.extra.dealer[key].title,
                            gmpClickable: true,
                        });

                        newMarker.addListener('click', ({domEvent, latLng}) => {
                            const { target } = domEvent;
                            infoWindow.close();
                            infoWindow.setContent(msg.extra.dealer[key].content);
                            infoWindow.open(locatorMap, newMarker);
                        });

                        markers.push(newMarker);
                    }

                    // Update center and zoom factor
                    locatorMap.setCenter(new google.maps.LatLng(msg.extra.center.lat, msg.extra.center.lng));
                    let latlng = [];
                    for(let key in msg.extra.dealer) {
                        latlng.push(new google.maps.LatLng(msg.extra.dealer[key].lat, msg.extra.dealer[key].lng));
                    }
                    let latlngbounds = new google.maps.LatLngBounds();
                    for(let i = 0; i < latlng.length; i++) {
                        latlngbounds.extend(latlng[i]);
                    }
                    locatorMap.fitBounds(latlngbounds);

                    // Add dealer data to div
                    $('.e-location').html(msg.html);
                },

                error: function(bo,di,ax) {
                    // console.log('ERROR! ' + di + ': ' + ax);
                }
            });
        });
    }

    $('.js-dealersearch2 input').on('blur', function() {
        // console.log('hoi');
        $.ajax({
            type: 'GET',
            url: wp_object.theme_url + '/xhr/find_dealer.php',
            data: {
                zip: $(this).val(),
                template: 'offer',
                limit: 3,
            },
            dataType: 'json',

            success: function(msg) {
                $('.js-showdealer').html(msg.html);
                $('input[name="' + wp_object.gf_offer_dealer_field + '"]').val(msg.id);
                $('input[name="dealer_id"][value="' + msg.id + '"').prop("checked", true);
            },

            error: function(obj, status, msg) {
                // console.log('ERROR! ' + status + ': ' + msg);
            }
        });
    });

    $('.js-showdealer').on('click', function() {
        let dealer_id = $('input[name="dealer_id"]:checked').val();
        if(typeof dealer_id !== 'undefined') {
            $('input[name="' + wp_object.gf_offer_dealer_field + '"]').val(dealer_id);
        }
    });

    $(document).on('click', '.js-contactdealer', function(ev) {
        ev.preventDefault();
        $('.js-dealersearch input').off('blur').val( $('.js-locatestore [name="zip"]').val() );
        let thisDealer = JSON.parse($(this).attr('data-dealer'));
        $.ajax({
            type: 'POST',
            url: wp_object.theme_url + '/partial/dealer_default.php',
            data: thisDealer,
            // dataType: 'json',
            success: function(msg) {
                console.log(msg);
                $('.js-showdealer').html(msg);
                $('input[name="' + wp_object.gf_offer_dealer_field + '"]').val(thisDealer.id);
                $('input[name="dealer_id"][value="' + thisDealer.id + '"').prop("checked", true);
                $('html,body').animate({scrollTop:$('.e-form').first().offset().top - 300}, 500);
                console.log($('.e-form').first().offset().top);
            }
        });
    });

    $('.e-button--pc').on('click', function(ev) {
        $('.js-dealersearch2 input').trigger('blur');
    });

    $('.js-locatestore form').submit(function(ev) {
        ev.preventDefault();
        return $('input', $(this)).trigger('blur');
    });

    $('.js-locatestore input').keyup(function(ev) {
        if(ev.which == 13) {
            ev.preventDefault();
            return $(this).trigger('blur');
        }
    })
});

var locatorMap, infoWindow, markers = [];
async function initLocatorMaps() {
    const { Map, InfoWindow } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
    
    window.InfoWindow = InfoWindow;
    window.AdvancedMarkerElement = AdvancedMarkerElement;

    locatorMap = new Map(document.getElementById('locatorMap'), {
        center: { lat: 52.132633209228516, lng: 5.357183933258057 },
        zoom: 7,
        mapId: "locatorMap",
        clickableIcons: false,
    });

    infoWindow = new InfoWindow();
}